import React from "react"
import PropTypes from "prop-types"
import { injectGlobal, ThemeProvider } from "styled-components"
import theme from "buoy-theme"
import { getSubdomain } from "../common/brands"


injectGlobal`
  html {
    box-sizing: border-box;
  }
  *, *:before, *:after {
    box-sizing: inherit;
  }
  body {
    font-family: "Roboto", Arial, Helvetica, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    padding: 0;
    margin: 0;
    letter-spacing: 0.2px;
  }
`

// Hacky redirect before page even loads for NYT
const subdomain = getSubdomain()
const useDashboard = subdomain === "nyt" || subdomain === "houstonmethodist"
if (typeof window !== "undefined" && useDashboard && window.location.pathname === "/") {
  window.location.replace("/dashboard/")
}

const Layout = ({ children, data }) => (
  <ThemeProvider theme={theme}>
    <div>
      {children()}
    </div>
  </ThemeProvider>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export const query = graphql`
  query SiteDataQuery {
    site {
      siteMetadata {
        title
        description
        symptomCheckerPath
        mainImagePath
      }
    }
  }
`

export default Layout



// WEBPACK FOOTER //
// ./src/layouts/index.js